const INFO = {
	main: {
		title: "Prathiba Ramesh",
		name: "Prathiba Ramesh",
		email: "prathibaramesh2120@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/PrathibaRamesh",
		linkedin: "https://www.linkedin.com/in/prathiba-ramesh-b19491157/",
		stackoverflow: "https://stackoverflow.com/",
	},

	homepage: {
		title: "Software Engineer | FullStack Web developer",
		description:
			"I am Prathiba Ramesh, a passionate and results-driven Software Engineer with over 5 years of experience and a master's degree in Computer Science. My journey in technology has been defined by a relentless pursuit of excellence and a commitment to continuous learning. Over the years, I have developed expertise in software development, system architecture, and performance optimization. I am proficient in a variety of programming languages and have a proven track record of designing and implementing scalable, efficient, and maintainable software systems.",
	},

	about: {
		title: "Hi! I'm Prathiba Ramesh... ",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. My most recent experience as a Software Engineer Intern at KQED Public Media involved leveraging Tableau and MongoDB for data-rich reports and dashboards, facilitated seamless data migration, and established a dynamic pipeline with Python. I automated report generation, enhanced data security, and integrated systems using HTML, CSS, and Python Flask. Throughout my Graduate program, I have developed full stack web applications using JavaScript, involving Node and ReactJS. Before this, I was a Software Engineer at Tata Consultancy Services where I worked on various projects involving C# and .Net Frameworks. ",
	},

	articles: {
		title: "Technical Journey",
		description:
			"Throughout my professional journey, I have consistently strived to make meaningful contributions to the success of each organization I have been a part of. My efforts have been driven by a commitment to excellence, collaboration, and a deep understanding of organizational goals. Below is a chronological account of my key contributions:",
	},

	projects: [
		{
			title: "iPlate, The Health App",
			description:
				"Led a team in developing a web app to monitor daily food intake, using ReactJS for the front-end, ChartJS for data visualization, NodeJS for the back-end, and MongoDB. Deployed on Google Cloud Platform, enabling users to track dietary habits.",
			logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
			linkText: "View Project",
			link: "https://github.com/PrathibaRamesh/iPlate-Health-App",
		},

		{
			title: "VR Engine for Structural Damage",
			description:
				"Created a VR training program for Structural Engineers using Unity and C#. Developed realistic post-hazard assessment scenarios with interactive VR-friendly UI, optimizing performance with Unity's Scene Management API.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/csharp/csharp.png",
			linkText: "View Project",
			link: "https://github.com/igouProto/VR-Engine-SFSU",
		},

		{
			title: "Visa-Wiz",
			description:
				"Designed Tableau visualizations to analyze H1B Visa trends, utilizing Python libraries for data processing. Integrated Tableau dashboards into a React app deployed on Cloudflare Pages.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/PrathibaRamesh/Visa-Wiz",
		},

		{
			title: "Gator Buddy",
			description:
				"Developed a web app for CSU (SFSU) students with an AI-powered chatbot using GPT-3, React for the front-end, Node.js for back-end, and MySQL for data, deployed on Google Cloud Platform (GCP)",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/PrathibaRamesh/SFSU-CSC-Help",
		},

		{
			title: "Automated Report Generator",
			description:
				"Created a Standalone application to generate reports automatically by execute SQL queries and SP's in the backend. Dynamically populate certain input choices into the query to efficiently fetch the data.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://github.com/PrathibaRamesh/KQED_Membership_ReportGenerator",
		},

		{
			title: "Expense Tracker App",
			description:
				"Developed an Expense Tracker App using WPF and C# libraries to record daily expenses and income, monitor monthly trend in investments and budgeting using visual charts.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/csharp/csharp.png",
			linkText: "View Project",
			link: "https://github.com/PrathibaRamesh/ExpenseTrackerWPF",
		},
	],
};

export default INFO;